<template>
  <div>
    <div class="panel">
      <div class="filter">
        <el-form
          label-position="right"
          class="search-form"
          label-width="80px"
          inline
          @submit.native.prevent
          size="small"
        >
          <el-form-item label="单号">
            <el-input
              v-model="filter.order_number"
              autocomplete="off"
              placeholder="搜索单号"
              @keyup.enter.native="
                filter.page = 1
                getData()
              "
            ></el-input>
          </el-form-item>
          <el-form-item label="包含仪器">
            <ProductSelect
              v-model="filter.product_id"
              :codeType="0"
              :applyFilter="true"
            ></ProductSelect>
          </el-form-item>
          <el-form-item label="发起基地">
            <BaseSelect
              v-model="filter.base_id"
              :clearable="true"
              :filterBlank="true"
            ></BaseSelect>
          </el-form-item>
          <el-form-item label="发起钻井">
            <DrillWellSelect
              v-model="filter.drill_well_id"
              :clearable="true"
              :filterBlank="true"
            ></DrillWellSelect>
          </el-form-item>
          <el-form-item label="接收基地" v-if="!condition.approving">
            <BaseSelect
              v-model="filter.approve_base_id"
              :clearable="true"
            ></BaseSelect>
          </el-form-item>
          <el-form-item label="接收钻井" v-if="!condition.approving">
            <DrillWellSelect
              v-model="filter.receive_well_id"
              :clearable="true"
            ></DrillWellSelect>
          </el-form-item>
          <el-form-item label="单据类型">
            <ItemStatusSelect
              v-model="filter.category"
              model="supplyCategory"
              :clearable="true"
            ></ItemStatusSelect>
          </el-form-item>
          <el-form-item label="状态">
            <ItemStatusSelect
              v-model="filter.status"
              model="supply"
              :filter="condition.approving ? [1] : []"
              :clearable="true"
            ></ItemStatusSelect>
          </el-form-item>
          <el-form-item label="提交日期">
            <el-date-picker
              v-model="filter.date"
              type="daterange"
              size="small"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <div style="margin-left: 80px">
          <el-button
            type="primary"
            size="small"
            @click="
              filter.page = 1
              getData()
            "
            >筛选</el-button
          >
          <el-button size="small" @click="getData(true)">重置</el-button>
        </div>
      </div>
    </div>
    <div class="panel mt-20">
      <el-button
        type="primary"
        size="small"
        icon="el-icon-plus"
        @click="
          model = {}
          dialogVisible = true
        "
        v-if="canAdd"
        >物资调拨</el-button
      >
      <el-table :data="list" size="small" class="mt-10">
        <el-table-column prop="order_number" label="单号">
          <template slot-scope="scope">
            <el-tag size="mini"
              ><ItemStatus
                :status="scope.row.category"
                model="supplyCategory"
              ></ItemStatus
            ></el-tag>
            <el-tag
              type="success"
              class="ml-5"
              size="mini"
              v-if="scope.row.delivery_category"
              ><ItemStatus
                :status="scope.row.delivery_category"
                model="supplyDelivery"
              ></ItemStatus
            ></el-tag>
            <div>
              {{ scope.row.order_number }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="base.name" label="发起地/接收地">
          <template slot-scope="scope">
            {{ scope.row.well.well_number || scope.row.base.name }}<br />
            {{
              scope.row.receive_well.well_number || scope.row.approve_base.name
            }}
          </template>
        </el-table-column>
        <el-table-column label="物资明细" min-width="150">
          <template slot-scope="scope">
            <div v-for="item in scope.row.items" :key="item.id">
              <el-tag size="mini" :type="appltItemStatusType[item.status]"
                >{{
                  item.category == 3 ? item.product.code : item.item.code
                }}（{{ item.category == 3 ? item.product.name : item.item.name
                }}{{ item.number ? ` x${item.number}` : '' }}）
              </el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="备注" align="left" prop="remark">
        </el-table-column>
        <el-table-column label="创建人/提交时间" align="center">
          <template slot-scope="scope">
            {{ scope.row.user.name }}
            <br />
            {{
              scope.row.status > 1
                ? $time(scope.row.created_at).format('YYYY-MM-DD')
                : '-'
            }}
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <ItemStatus :status="scope.row.status" model="supply"></ItemStatus>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="150">
          <template slot-scope="scope">
            <template v-if="scope.row.user_id == $store.state.userInfo.id">
              <el-popconfirm
                title="确认删除吗？"
                @confirm="hanldeDelte(scope.row, scope.$index)"
                :key="Math.random()"
              >
                <el-button
                  slot="reference"
                  v-if="scope.row.status == 1"
                  v-permission="Auth.supplyDelete"
                  type="text"
                  size="small"
                  class="text-danger"
                  >删除</el-button
                >
              </el-popconfirm>
              <el-button
                type="text"
                size="small"
                class="ml-5"
                v-if="scope.row.status == 1"
                @click="handleEdit(scope.$index, scope.row)"
                v-permission="Auth.supplyEdit"
                >编辑</el-button
              >
              <el-popconfirm
                title="确认提交吗？"
                @confirm="handleApplyStart(scope.row, scope.$index)"
                :key="Math.random()"
              >
                <el-button
                  class="ml-5"
                  slot="reference"
                  v-if="scope.row.status == 1"
                  v-permission="Auth.supplyStart"
                  type="text"
                  size="small"
                  >提交</el-button
                >
              </el-popconfirm>
              <el-popconfirm
                :key="Math.random()"
                title="确认撤回吗？"
                @confirm="handleApplyRecall(scope.row, scope.$index)"
              >
                <el-button
                  class="ml-5 text-danger"
                  slot="reference"
                  v-permission="Auth.supplyRecall"
                  v-if="scope.row.status == 2"
                  type="text"
                  size="small"
                  >撤回</el-button
                >
              </el-popconfirm>
            </template>

            <template
              v-if="
                condition.approving &&
                [1, 3].includes(scope.row.entity_type) &&
                scope.row.approve_base_id == $store.state.userInfo.base_id &&
                [2, 5].includes(scope.row.status)
              "
            >
              <el-popconfirm
                title="确认全部接收吗？（已单独拒收的除外）"
                @confirm="handleApplyOption(scope.row, scope.$index, true)"
                :key="Math.random()"
              >
                <el-button
                  class="ml-5"
                  slot="reference"
                  v-permission="Auth.supplyReceive"
                  type="text"
                  size="small"
                  :key="`receive${scope.$index}`"
                  >接收</el-button
                >
              </el-popconfirm>
              <el-button
                class="ml-5 text-danger"
                v-permission="Auth.supplyReject"
                @click="handleApplyOption(scope.row, scope.$index)"
                type="text"
                size="small"
                >拒收</el-button
              >
            </template>

            <el-button
              type="text"
              size="small"
              class="ml-5"
              v-if="scope.row.status > 1"
              @click="handleExport(scope.row)"
              v-permission="
                condition.approving
                  ? Auth.supplyReceiveExport
                  : Auth.supplyExport
              "
              >导出</el-button
            >
            <el-button
              type="text"
              size="small"
              class="ml-5"
              v-permission="
                condition.approving
                  ? Auth.supplyReceiveDetail
                  : Auth.supplyDetail
              "
              @click="$router.push(`${$route.path}/${scope.row.id}`)"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
      <Former
        :model="model"
        :show.sync="dialogVisible"
        @created="createdCallback"
        @updated="updatedCallback"
      ></Former>
      <PreviewFomer
        :item="model"
        :show.sync="previewDialogVisible"
      ></PreviewFomer>
    </div>
  </div>
</template>

<script>
import {
  applyList,
  applyDelete,
  applyStart,
  applyRecall,
  applyOption,
} from '@/service/getData'
import Former from './former'
import PreviewFomer from './PreviewFomer.vue'
import BaseSelect from '@/components/select/base_select.vue'

export default {
  props: {
    condition: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    Former,
    PreviewFomer,
    BaseSelect,
  },
  watch: {
    'filter.page': function () {
      this.getData()
    },
  },
  computed: {
    canAdd() {
      return !this.condition.approving && this.hasAuth('supplyNew')
    },
  },
  data() {
    return {
      model: {},
      filter: {
        page: 1,
        size: 10,
        status: '',
        category: '',
        product_id: '',
        base_id: '',
        drill_well_id: '',
        approve_base_id: '',
        receive_well_id: '',
        date: '',
        order_number: '',
      },
      total: 0,
      editIndex: 0,
      list: [],
      dialogVisible: false,
      previewDialogVisible: false,
      appltItemStatusType: [
        'info',
        'info',
        'primary',
        'success',
        'danger',
        'primary',
        'info',
      ],
    }
  },
  created() {
    if (this.$route.query.filter) {
      this.filter = this.filterDecode(this.$route.query.filter)
    }
    this.getData()
  },
  methods: {
    async getData(reset = false) {
      if (reset) {
        this.filter.page = 1
        this.filter.status = ''
        this.filter.category = ''
        this.filter.product_id = ''
        this.filter.base_id = ''
        this.filter.drill_well_id = ''
        this.filter.receive_well_id = ''
        this.filter.approve_base_id = ''
        this.filter.date = ''
        this.filter.order_number = ''
      }

      this.$router.replace({
        query: this.filterEncode(this.filter),
      })

      let params = Object.assign({}, this.filter, this.condition)
      params.page -= 1
      if (params.date && params.date.length == 2) {
        params.start_date = params.date[0]
        params.end_date = params.date[1]
      }

      let res = await applyList(params)
      if (res.code == 0) {
        this.list = res.data.list
        this.total = res.data.count
      }
    },
    createdCallback(data) {
      this.list.unshift(data)
    },
    updatedCallback(data) {
      this.$set(this.list, this.editIndex, data)
    },
    handleEdit(index, item) {
      this.model = this.clone(item)
      this.editIndex = index
      this.dialogVisible = true
    },

    async handleApplyStart(item, index) {
      let res = await applyStart(item.id)
      if (res.code == 0) {
        this.$set(this.list, index, res.data)
      }
    },

    async handleApplyRecall(item, index) {
      let res = await applyRecall(item.id)
      if (res.code == 0) {
        this.$set(this.list, index, res.data)
        this.$notify.success('撤回成功！')
      }
    },

    async applyOption(data, index) {
      let res = await applyOption(data)
      if (res.code == 0) {
        this.$set(this.list, index, res.data)
        this.$notify.success(`已${data.pass ? '接' : '拒'}收！`)
      }
    },

    handleExport(item) {
      this.model = item
      this.previewDialogVisible = true
    },

    //接收、拒收
    handleApplyOption(item, index, isPass = false) {
      let data = {
        id: item.id,
        pass: isPass,
      }

      if (isPass) {
        this.applyOption(data, index)
        return
      }

      this.$prompt('拒收原因', '全部拒收（已单独接收的除外）', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'textarea',
        inputValidator: (value) => {
          return !!value
        },
        inputErrorMessage: '拒收原因不能为空',
      }).then(({ value }) => {
        data.remark = value
        this.applyOption(data, index)
      })
    },

    async hanldeDelte(item, index) {
      let res = await applyDelete(item.id)
      if (res.code == 0) {
        this.list.splice(index, 1)
      }
    },
  },
}
</script>